import { render, staticRenderFns } from "./ImportLogisticSubscribeMessage.vue?vue&type=template&id=3db96ab2"
import script from "./ImportLogisticSubscribeMessage.vue?vue&type=script&lang=js"
export * from "./ImportLogisticSubscribeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports